<div class="error-feedback-container">
    <div class="content-wrapper">
        <div class="error-card">
            <div class="title-container">
                <h1 class="error-title">
                    {{ title | translate }}
                </h1>
                <p class="error-description">
                    {{ description | translate }}
                </p>
            </div>

            <div class="buttons-container">
                <lib-button id="btn-login" label="Login" type="primary" [disabled]="false" (clickButton)="redirectToWhatsAppChatbot()">
                    {{ chatButton | translate }}
                </lib-button>
                <lib-button id="btn-login" label="Login" type="secondary" [disabled]="false" (clickButton)="doLogout()">
                    {{ closeButton | translate }}
                </lib-button>
            </div>
        </div>
    </div>
</div>